import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CarilerPage from "@/pages/Cariler";
import CariDetailPage from "@/pages/CariDetail";
import HesaplarPage from "@/pages/Hesaplar";
import HesapDetailPage from "@/pages/HesapDetail";
import HareketlerPage from "@/pages/Hareketler";
import RaporlarPage from "@/pages/Raporlar";
import RezervasyonlarPage from "@/pages/Rezervasyonlar";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/giris" element={<LoginPage />} />
          <Route path="/kayit" element={<RegisterPage />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/cariler" element={<ProtectedRoute><CarilerPage /></ProtectedRoute>} />
          <Route path="/cariler/:id" element={<ProtectedRoute><CariDetailPage /></ProtectedRoute>} />
          <Route path="/hesaplar" element={<ProtectedRoute><HesaplarPage /></ProtectedRoute>} />
          <Route path="/hesaplar/:id" element={<ProtectedRoute><HesapDetailPage /></ProtectedRoute>} />
          <Route path="/hareketler" element={<ProtectedRoute><HareketlerPage /></ProtectedRoute>} />
          <Route path="/raporlar" element={<ProtectedRoute><RaporlarPage /></ProtectedRoute>} />
          <Route path="/rezervasyonlar" element={<ProtectedRoute><RezervasyonlarPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
